import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class IsentropicService {

  p_pt: number;

  constructor() { 
    this.p_pt = 0;
    
  }

  getIsentropic(ga:Number, ma:Number) {

    let isentropicMap = new Map();
    let g = Number(ga);
    let m = Number(ma);

    let g2 = Math.pow(g,2);
    let gm1 = g-1;
    let gp1 = g+1;
    let gm1_2 = gm1/2;
    let gp1_2 = gp1/2;
    let m2 = Math.pow(m,2);
    let invm2 = 1/(m2);
    let invm = 1/m;
    let frac = gp1 / (2*(gm1));

    this.p_pt = Math.pow( 1 / ( 1 + (gm1_2 * m2)), (g/gm1) );

    let a_as = (Math.pow( gp1_2, -frac)) *  invm * (Math.pow( 1+ (gm1_2 *m2), frac));

    let t_tt = Math.pow(1 + (gm1_2 * m2), -1);

    let pa_ptas =  a_as * this.p_pt;

    let radian_mu = Math.asin(1/m);
    let mach_angle = (180/Math.PI) * radian_mu;

    let m2_1 = Math.pow(m, 2) - 1;
    let part1 = Math.sqrt( gp1/gm1 );
    let part2 = Math.atan(  Math.sqrt ( (gm1/gp1) * m2_1 ) );
    let part3 = Math.atan( Math.sqrt( m2_1) ) ;
    let p_m = (part1 * part2) - part3;
    let p_m_r = (180/Math.PI) * p_m;

    // let cfopt =  Math.sqrt( ( (2*Math.pow(g, 2))/gm1) * Math.pow((2/gp1), (gp1/gm1)) * ( 1 - Math.pow(p_pt, (gp1/g)) ) );


    let cfopt = Math.sqrt( Math.pow( (2/gp1), (gp1/gm1) ) * g2 * m2 * 1/( 1 + (gm1/2)*m2) );

    let rho_rhot = Math.pow( 1 / ( 1 + ( (gm1/2) * m2) ) , 1/gm1 );

    isentropicMap.set("p_pt", this.p_pt);
    isentropicMap.set("A_A*", a_as);
    isentropicMap.set("T_Tt", t_tt);
    isentropicMap.set("pA_ptA*", pa_ptas);
    isentropicMap.set("mach-angle", mach_angle);
    isentropicMap.set("rho/rhot", rho_rhot);

    // Optimum thrust coefficient
    isentropicMap.set("C_Fopt", cfopt);


    isentropicMap.set("Prandlt-Meyer", p_m_r);
    isentropicMap.set("mach-angle", mach_angle);

    return isentropicMap;

  }
}
